export default "__VITE_PUBLIC_ASSET__433ca7af__"